import React from 'react';
import firstLogoSapore from '../media/logos/logo-sapore.png'
import secondLogoSapore from '../media/logos/id-sdp.png'

const Footer = () => {
    return (
        <footer>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="text-center">
                            <img
                                src={secondLogoSapore}
                                alt="Logo de Sapore Di Pane"
                                className="hidden-xs"
                            />
                            <div className="visible-xs">
                                <img
                                    src={firstLogoSapore}
                                    alt="Logo Sapore Di Pane"
                                />
                            </div>
                            <p className="font12">© 2017 Sapore Di Pane. Todos los derechos reservados.</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;